(() => {
  'use strict';

  if (window.PWAdvisorCardCleanupV2Loaded) return;
  window.PWAdvisorCardCleanupV2Loaded = true;

  const PAGE_RE = /\/pages\/(?:wasmachine|vaatwasser)-adviseur\/?$/;
  const ROOT_SELECTOR = '[id^="shopify-section-"][id*="advisor_apps"], .cc-apps';
  let scheduled = false;

  if (!PAGE_RE.test(window.location.pathname)) return;

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  function isEnergyVisual(element) {
    if (!(element instanceof Element)) return false;

    const className =
      typeof element.className === 'string'
        ? element.className
        : element.className?.baseVal || '';
    const alt = element.getAttribute('alt') || '';
    const aria = element.getAttribute('aria-label') || '';
    const src =
      element.getAttribute('src') ||
      element.querySelector?.('use')?.getAttribute('href') ||
      element.querySelector?.('use')?.getAttribute('xlink:href') ||
      '';

    if (/pw-energy-label|energy-label|energielabel|energieklasse/i.test(
      `${className} ${alt} ${aria}`
    )) {
      return true;
    }

    const filename = src.split('/').pop()?.split(/[?#]/)[0] || '';

    return (
      /^[a-g]\.svg$/i.test(filename) ||
      /^(?:a-plus|aplusplus|aplusplusplus)\.(?:svg|webp|png)$/i.test(filename)
    );
  }

  function energyVisuals(scope) {
    return Array.from(scope.querySelectorAll('img, svg')).filter(isEnergyVisual);
  }

  function nearestPriceArea(element, card) {
    let current = element.parentElement;
    let fallback = null;

    for (
      let depth = 0;
      current && depth < 7;
      depth += 1, current = current.parentElement
    ) {
      const text = cleanText(current.textContent);

      if (/€\s*\d/.test(text) && text.length <= 240) {
        fallback = current;
        if (energyVisuals(current).length) return current;
      }

      if (current === card) break;
    }

    return fallback;
  }

  function removePriceEnergyLabels(card) {
    card
      .querySelectorAll(
        '[data-pw-advisor-price="true"], [data-pw-final-price="true"]'
      )
      .forEach((priceHost) => {
        const area = nearestPriceArea(priceHost, card);
        if (!area || area === card) return;

        energyVisuals(area).forEach((visual) => visual.remove());
      });

    energyVisuals(card).forEach((visual) => {
      let current = visual.parentElement;

      for (
        let depth = 0;
        current && depth < 6;
        depth += 1, current = current.parentElement
      ) {
        const text = cleanText(current.textContent);

        if (/€\s*\d/.test(text) && text.length <= 240) {
          visual.remove();
          break;
        }

        if (current === card) break;
      }
    });
  }

  function keepOneEnergyLabel(card) {
    const visuals = energyVisuals(card);
    if (visuals.length <= 1) return;

    visuals.slice(1).forEach((visual) => visual.remove());
  }

  function restoreImageColour(root) {
    root.querySelectorAll('img, picture, figure, [class*="image"]').forEach(
      (element) => {
        if (!(element instanceof HTMLElement)) return;
        if (isEnergyVisual(element) || element.closest('.pw-energy-label-icon')) {
          return;
        }

        element.style.setProperty('filter', 'none', 'important');
        element.style.setProperty('-webkit-filter', 'none', 'important');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('mix-blend-mode', 'normal', 'important');
      }
    );
  }

  function enhance() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (!(root instanceof HTMLElement) || !root.querySelector('img')) return;

      restoreImageColour(root);

      root.querySelectorAll('[data-pw-advisor-card="true"]').forEach((card) => {
        removePriceEnergyLabels(card);
        keepOneEnergyLabel(card);
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  }

  function init() {
    enhance();

    new MutationObserver((records) => {
      const relevant = records.some(
        (record) =>
          record.type === 'characterData' ||
          record.type === 'attributes' ||
          Array.from(record.addedNodes).some(
            (node) => node.nodeType === Node.ELEMENT_NODE
          )
      );

      if (relevant) schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'data-pw-advisor-card',
        'data-pw-advisor-price',
        'data-pw-final-price'
      ]
    });

    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
